function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "99 142.04 0 225.72 0 400 99 316.32 99 142.04"
});

var _ref3 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "197 0 109 80 109 310 197 230 197 0"
});

var _ref4 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "285 310 197 230 197 0 285 80 285 310"
});

var _ref5 =
/*#__PURE__*/
React.createElement("rect", {
  y: 424,
  width: 395,
  height: 69
});

var _ref6 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "198 271 0 424 395 424 198 271"
});

var _ref7 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "395 399.98 294 316.3 294 142.02 395 225.7 395 399.98"
});

var SvgCommander = function SvgCommander(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 395 493",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCommander, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/commander.3c56e95d.svg";
export { ForwardRef as ReactComponent };